import React from "react";
import { Button } from "../../../components";

export default function BecomePartner(props) {
	return (
		<section className="welcome-section no-pt">
			<h2>We are open to partnership.</h2>

			<ul>
				<li>
					<p className="text-justify">
						We are open to partnership with individuals or
						organizations interested in a collaborative effort to
						implement any of our programs.
					</p>
				</li>
				<li>
					<p className="text-justify">
						Are you an individual or organization interested in a
						joint effort to deliver any of our programs? “Looking to
						partner with us? We would love to hear about your ideas!
					</p>
				</li>
			</ul>

			<Button linkTo="https://bit.ly/3HPartners">Partner with us</Button>
		</section>
	);
}
